import { GET_PORTFOLIO, SET_LOADING_PORTFOLIO, SET_PAGINATION_PORTFOLIO } from '../constant';

const initialState = {
  portfolio: [],
  loadingPortfolio: false,
  portfolioPagination: 0,
  totalPortfolio: 0,
};

const portfolioReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_PORTFOLIO: {
      return {
        ...state,
        loadingPortfolio: action?.payload,
      };
    }
    case SET_PAGINATION_PORTFOLIO: {
      return {
        ...state,
        portfolioPagination: action?.payload,
      };
    }
    case GET_PORTFOLIO: {
      return {
        ...state,
        portfolio: action?.payload?.data || [],
        totalPortfolio: action?.payload?.total,
        loadingPortfolio: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default portfolioReducer;
